import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import colors from 'vuetify/lib/util/colors';
import store from '../src/store'
import '@mdi/font/css/materialdesignicons.css';
import Nl2br from 'vue-nl2br'


Vue.config.productionTip = false;

Vue.component('nl2br', Nl2br)

const selector = '#urochat_app';
// const selector = '#app';
const mountEl = document.querySelector(selector);
// possible settings:
//   'websocket', 'authtoken', 'site', 'roomid',
//   'hideuserscount', 'domainprofilelink',
//   'guestcanwrite', 'lang'
Vue.prototype.$settings = {...mountEl.dataset};


new Vue({
  store,
  colors: colors,
  vuetify,
  render: h => h(App),
}).$mount(selector)
